import { ReducerRegistry } from 'store';
import {
  CREATE_PRODUCT_PAYOUT,
  CREATE_PRODUCT_COLLECTION,
  FETCH_PRODUCTS,
  PRODUCT_ASYNC_START,
  PRODUCT_ASYNC_END,
  PRODUCT_LOG_ERROR,
  UDPDATE_PRODUCTS_FILTERS,
  UDPDATE_PRODUCTS_PAGINATION,
  UPDATE_PRODUCT_TYPE,
  FETCH_PRODUCT_DETAILS,
  RESET_PRODUCT_DETAILS,
  UPDATE_STATUS_ASYNC,
  RESET_PRODUCT_TRANSACTIONS,
  PRODUCT_FETCH_CLEAR,
  FETCH_PRODUCT_OFFERINGS,
  FETCH_PRODUCT_FIELDS,
  FETCH_PRODUCT_KEYS,
  EDIT_PRODUCT_COLLECTION,
} from '../types';

const INIT_STATE = {
  products: {
    data: [],
    meta: {},
    details: {},
    fields: {},
    inProgress: false,
    pagination: {
      page: 0,
      size: 15,
      status: null,
      startDate: null,
      endDate: null,
      order: 'DESC',
      sortBy: 'createdAt',
    },
    filters: {},
    error: '',
    productType: '',
  },
  transactions: {
    data: [],
    meta: {},
    pagination: { page: 0, size: 15 },
    filters: {},
    inProgress: false,
    error: '',
  },
};

export const productReducer = ReducerRegistry.register(
  'products',
  (state = INIT_STATE, { type, payload, subType }) => {
    switch (type) {
      case FETCH_PRODUCTS:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            data: payload.data,
            meta: payload.meta,
            inProgress: false,
          },
        };

      case FETCH_PRODUCT_DETAILS:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            details: payload,
            inProgress: false,
          },
        };

      case FETCH_PRODUCT_KEYS:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            keys: payload,
            inProgress: false,
          },
        };

      case FETCH_PRODUCT_FIELDS:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            fields: payload,
            inProgress: false,
          },
        };

      case RESET_PRODUCT_DETAILS:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            keys: payload,
            inProgress: false,
          },
        };

      case PRODUCT_FETCH_CLEAR:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            details: {},
          },
        };

      case RESET_PRODUCT_TRANSACTIONS:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            data: [],
            meta: [],
            inProgress: true,
          },
        };

      case PRODUCT_ASYNC_START:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            inProgress: true,
          },
        };

      case PRODUCT_ASYNC_END:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            inProgress: false,
          },
        };

      case UDPDATE_PRODUCTS_FILTERS:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            filters: payload,
            pagination: INIT_STATE[subType].pagination,
          },
        };

      case UDPDATE_PRODUCTS_PAGINATION:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            pagination: {
              ...state[subType].pagination,
              page: payload,
            },
          },
        };

      case PRODUCT_LOG_ERROR:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            inProgress: false,
            error: payload,
          },
        };
      case CREATE_PRODUCT_PAYOUT:
        return {
          ...state,
          inProgress: false,
          errors: payload || null,
        };

      case CREATE_PRODUCT_COLLECTION:
        return {
          ...state,
          products: {
            ...state.products,
            inProgress: false,
            productType: payload,
            errors: payload || null,
          },
        };
      case EDIT_PRODUCT_COLLECTION:
        return {
          ...state,
          products: {
            ...state.products,
            inProgress: false,
            productType: payload,
            errors: payload || null,
          },
        };
      case UPDATE_STATUS_ASYNC:
        return {
          ...state,
          products: { ...state.products, inProgress: payload },
        };
      case UPDATE_PRODUCT_TYPE:
        return {
          ...state,
          products: {
            ...state.products,
            inProgress: false,
            productType: payload,
          },
        };
      case FETCH_PRODUCT_OFFERINGS:
        return {
          ...state,
          [subType]: {
            ...state[subType],
            offerings: payload,
            inProgress: false,
          },
        };
      default:
        return state;
    }
  },
);
